import axios from '@/axios'

export default {
  get(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, { params })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  post(url, item) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  put(url, item) {
    return new Promise((resolve, reject) => {
      axios
        .put(url, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  delete(url) {
    return new Promise((resolve, reject) => {
      axios
        .delete(url)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
